<div *ngIf="navigationMenu && navigationMenu[0]?.subNav.length > 0" class="open-btn-container"
    [ngClass]="isNavHidden ? '':'hiddenBtn'">
    <a href="javascript:void(0)" class="openBtn px-3" (click)="toggleNav(false)">&#187;</a>
</div>
<div *ngIf="navigationMenu && navigationMenu[0]?.subNav.length > 0" [ngClass]="isNavHidden ? 'nav-hidden':''"
    class="sidebar-wrapper">
    <div class="list-group list-group-flush px-2">
        <a href="javascript:void(0)" class="closeBtn px-3" (click)="toggleNav(true)">&#171;</a>
        <ng-container *ngFor="let topNavitem of navigationMenu">
            <ng-container *ngFor="let sideNavitem of topNavitem.subNav">
                <a class="list-group-item list-group-item-action" routerLinkActive="active" *ngIf="!sideNavitem.subNav"
                    [routerLink]="topNavitem.route + sideNavitem.route" style="display: flex;">
                    <div class="nav-name">{{sideNavitem.name | translate}}</div>
                    <div  class="warning-icon">
                        <span class="material-icons" *ngIf="sideNavitem?.isButtonRequired"  [matTooltip]="sideNavitem?.hoverMsg | translate"
                matTooltipClass="asp-custom-tooltip">info</span>
                    </div>
                    </a>
                <div *ngIf="!!sideNavitem.subNav" routerLinkActive="open">
                    <a href="javascript:void(0)" class="list-group-item list-group-item-action list-parent-item mb-0">
                        {{sideNavitem.name | translate}}
                    </a>
                    <div class="w-100">
                        <a *ngFor="let childNavitem of sideNavitem.subNav"
                            class="list-group-item list-group-item-action child-nav mx-auto" routerLinkActive="active"
                            [routerLink]="sideNavitem.name === 'navigation.customer' ? topNavitem.route + childNavitem.route : topNavitem.route + sideNavitem.route + childNavitem.route">
                            {{childNavitem.name | translate}}
                            <span *ngIf="allowedSideNavWithCount(childNavitem)" class="appt-count" [class.pendingCount]="childNavitem.name === 'navigation.pendingAppointments' || childNavitem.name === 'navigation.pending'" [class.completedCount]="childNavitem.name === 'navigation.completed'">
                                <div class="count">{{childNavitem?.count}}</div>
                            </span> 
                        </a>
                    </div>
                </div>
            </ng-container>
        </ng-container>  
        <app-splitter class='app-splitter' [config]="'horizontal 100% 0 -4px 550px'" *ngIf="isDeliveryChecklist"></app-splitter>
        <span *ngIf="isDeliveryChecklist" style="margin-top: 0.5rem;"><h5 class="search-header">{{'deliveryChecklist.searchAllRecords' | translate}}</h5></span>
        <div class="searchFilter" *ngIf="isDeliveryChecklist">
            <form [formGroup]="searchForm">
                <div>
                    <mat-radio-group color="primary" formControlName="searchField">
                        <div>
                            <mat-radio-button disableRipple value="vinFilter">
                            </mat-radio-button>
                            <span>{{'navigation.vin' | translate}}</span>
                        </div>
                        <div>
                            <mat-radio-button disableRipple value="contactInfoFilter">
                            </mat-radio-button>
                            <span>{{'navigation.contactInfo' | translate}}</span>
                        </div>
                    </mat-radio-group>
                </div>
                <div style="margin-left: 0.8rem;">
                    <mat-form-field class="mat-input-container anime-element" appearance="outline" style="width:95%">
                        <div style="width: 90%;">
                            <input matInput (keydown.Enter)="fetchSearchRecords()" formControlName="searchInput">
                        </div>
                        <div style="position: absolute;margin-left: 7.5rem;margin-top: 0.1rem;">
                            <mat-icon class="search-icon" (click)="fetchSearchRecords()">search</mat-icon>
                        </div>
                    </mat-form-field>
                </div>
            </form>
        </div>
    </div>
</div>
